
import {
  defineComponent,
  computed,
} from 'vue';

export default defineComponent({
  props: {
    size: {
      type: String,
      required: false,
      default: () => null,
    },
  },

  setup(props) {
    const spacerClass = computed(() => {
      switch (props.size) {
        case 's':
          return 'small';
        case 'm':
          return 'medium';
        case 'l':
          return 'large';
        default:
          return props.size;
      }
    });

    return {
      spacerClass,
    };
  },
});
